/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 18.9998H10M14 11.9998H22M2 4.99976H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 18.9998H22M19 18.9998C19 20.6566 17.6569 21.9998 16 21.9998C14.3431 21.9998 13 20.6566 13 18.9998C13 17.3429 14.3431 15.9998 16 15.9998C17.6569 15.9998 19 17.3429 19 18.9998ZM2 11.9998H5M5 11.9998C5 13.6566 6.34315 14.9998 8 14.9998C9.65685 14.9998 11 13.6566 11 11.9998C11 10.3429 9.65685 8.99976 8 8.99976C6.34315 8.99976 5 10.3429 5 11.9998ZM19 4.99976H22M19 4.99976C19 6.65661 17.6569 7.99976 16 7.99976C14.3431 7.99976 13 6.65661 13 4.99976C13 3.3429 14.3431 1.99976 16 1.99976C17.6569 1.99976 19 3.3429 19 4.99976Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M13 4.99976C13 3.3429 14.3431 1.99976 16 1.99976C17.6569 1.99976 19 3.3429 19 4.99976C19 6.65661 17.6569 7.99976 16 7.99976C14.3431 7.99976 13 6.65661 13 4.99976Z"
					fill="currentColor"
				/>
				<path
					d="M13 18.9998C13 17.3429 14.3431 15.9998 16 15.9998C17.6569 15.9998 19 17.3429 19 18.9998C19 20.6566 17.6569 21.9998 16 21.9998C14.3431 21.9998 13 20.6566 13 18.9998Z"
					fill="currentColor"
				/>
				<path
					d="M5 11.9998C5 10.3429 6.34315 8.99976 8 8.99976C9.65685 8.99976 11 10.3429 11 11.9998C11 13.6566 9.65685 14.9998 8 14.9998C6.34315 14.9998 5 13.6566 5 11.9998Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M19 18.9998H22M19 18.9998C19 20.6566 17.6569 21.9998 16 21.9998C14.3431 21.9998 13 20.6566 13 18.9998C13 17.3429 14.3431 15.9998 16 15.9998C17.6569 15.9998 19 17.3429 19 18.9998ZM2 11.9998H5M5 11.9998C5 13.6566 6.34315 14.9998 8 14.9998C9.65685 14.9998 11 13.6566 11 11.9998C11 10.3429 9.65685 8.99976 8 8.99976C6.34315 8.99976 5 10.3429 5 11.9998ZM19 4.99976H22M19 4.99976C19 6.65661 17.6569 7.99976 16 7.99976C14.3431 7.99976 13 6.65661 13 4.99976C13 3.3429 14.3431 1.99976 16 1.99976C17.6569 1.99976 19 3.3429 19 4.99976ZM2 18.9998H10M14 11.9998H22M2 4.99976H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 1.50012C14.067 1.50012 12.5 3.06713 12.5 5.00012C12.5 6.93312 14.067 8.50012 16 8.50012C17.6755 8.50012 19.0761 7.32278 19.4195 5.75025L22 5.75025C22.4142 5.75025 22.75 5.41446 22.75 5.00025C22.75 4.58604 22.4142 4.25025 22 4.25025L19.4195 4.25025C19.0762 2.6776 17.6756 1.50012 16 1.50012ZM4.5806 12.7503L2 12.7503C1.58579 12.7503 1.25 12.4145 1.25 12.0003C1.25 11.586 1.58579 11.2503 2 11.2503L4.58054 11.2503C4.92383 9.6776 6.32442 8.50012 8.00003 8.50012C9.93302 8.50012 11.5 10.0671 11.5 12.0001C11.5 13.9331 9.93302 15.5001 8.00003 15.5001C6.32451 15.5001 4.92398 14.3228 4.5806 12.7503ZM12.5 19.0001C12.5 17.0671 14.067 15.5001 16 15.5001C17.6756 15.5001 19.0762 16.6776 19.4195 18.2502L22 18.2502C22.4142 18.2502 22.75 18.586 22.75 19.0002C22.75 19.4145 22.4142 19.7502 22 19.7502L19.4195 19.7502C19.0761 21.3228 17.6755 22.5001 16 22.5001C14.067 22.5001 12.5 20.9331 12.5 19.0001ZM2 4.25025C1.58579 4.25025 1.25 4.58604 1.25 5.00025C1.25 5.41446 1.58579 5.75025 2 5.75025L10 5.75025C10.4142 5.75025 10.75 5.41446 10.75 5.00025C10.75 4.58604 10.4142 4.25025 10 4.25025L2 4.25025ZM14 11.2503C13.5858 11.2503 13.25 11.586 13.25 12.0003C13.25 12.4145 13.5858 12.7503 14 12.7503L22 12.7502C22.4142 12.7502 22.75 12.4145 22.75 12.0002C22.75 11.586 22.4142 11.2502 22 11.2502L14 11.2503ZM2 18.2502C1.58579 18.2502 1.25 18.586 1.25 19.0002C1.25 19.4145 1.58579 19.7502 2 19.7502L10 19.7502C10.4142 19.7502 10.75 19.4145 10.75 19.0002C10.75 18.586 10.4142 18.2502 10 18.2502L2 18.2502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19 18.9998H22M19 18.9998C19 20.6566 17.6569 21.9998 16 21.9998M19 18.9998C19 17.3429 17.6569 15.9998 16 15.9998C14.3431 15.9998 13 17.3429 13 18.9998C13 19.3504 13.0602 19.687 13.1707 19.9998M2 11.9998H5M5 11.9998C5 13.6566 6.34315 14.9998 8 14.9998C9.65685 14.9998 11 13.6566 11 11.9998C11 10.3429 9.65685 8.99976 8 8.99976C6.34315 8.99976 5 10.3429 5 11.9998ZM19 4.99976H22M19 4.99976C19 6.65661 17.6569 7.99976 16 7.99976C14.3431 7.99976 13 6.65661 13 4.99976C13 4.64912 13.0602 4.31253 13.1707 3.99976M19 4.99976C19 3.3429 17.6569 1.99976 16 1.99976M2 18.9998H10M14 11.9998H22M2 4.99976H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19 18.9998H22M19 18.9998C19 20.6567 17.6569 21.9998 16 21.9998C14.3431 21.9998 13 20.6567 13 18.9998C13 17.343 14.3431 15.9998 16 15.9998C17.6569 15.9998 19 17.343 19 18.9998ZM2 11.9998H5M5 11.9998C5 13.6567 6.34315 14.9998 8 14.9998C9.65685 14.9998 11 13.6567 11 11.9998C11 10.343 9.65685 8.99982 8 8.99982C6.34315 8.99982 5 10.343 5 11.9998ZM19 4.99982H22M19 4.99982C19 6.65667 17.6569 7.99982 16 7.99982C14.3431 7.99982 13 6.65667 13 4.99982C13 3.34296 14.3431 1.99982 16 1.99982C17.6569 1.99982 19 3.34296 19 4.99982ZM2 18.9998H10M14 11.9998H22M2 4.99982H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 5.00013C1.25 4.58591 1.58579 4.25013 2 4.25013L10 4.25013C10.4142 4.25013 10.75 4.58591 10.75 5.00013C10.75 5.41434 10.4142 5.75013 10 5.75013L2 5.75013C1.58579 5.75013 1.25 5.41434 1.25 5.00013ZM18.25 5.00013C18.25 4.58591 18.5858 4.25013 19 4.25013L22 4.25013C22.4142 4.25013 22.75 4.58591 22.75 5.00013C22.75 5.41434 22.4142 5.75013 22 5.75013L19 5.75013C18.5858 5.75013 18.25 5.41434 18.25 5.00013ZM13.25 12.0001C13.25 11.5859 13.5858 11.2501 14 11.2501L22 11.2501C22.4142 11.2501 22.75 11.5859 22.75 12.0001C22.75 12.4143 22.4142 12.7501 22 12.7501L14 12.7501C13.5858 12.7501 13.25 12.4143 13.25 12.0001ZM1.25 12.0001C1.25 11.5859 1.58579 11.2501 2 11.2501L5 11.2501C5.41421 11.2501 5.75 11.5859 5.75 12.0001C5.75 12.4143 5.41421 12.7501 5 12.7501L2 12.7501C1.58579 12.7501 1.25 12.4143 1.25 12.0001ZM18.25 19.0001C18.25 18.5859 18.5858 18.2501 19 18.2501L22 18.2501C22.4142 18.2501 22.75 18.5859 22.75 19.0001C22.75 19.4143 22.4142 19.7501 22 19.7501L19 19.7501C18.5858 19.7501 18.25 19.4143 18.25 19.0001ZM1.25 19.0001C1.25 18.5859 1.58579 18.2501 2 18.2501L10 18.2501C10.4142 18.2501 10.75 18.5859 10.75 19.0001C10.75 19.4143 10.4142 19.7501 10 19.7501L2 19.7501C1.58579 19.7501 1.25 19.4143 1.25 19.0001Z"
				fill="currentColor"
			/>
			<path
				d="M16 1.5C14.067 1.5 12.5 3.067 12.5 5C12.5 6.933 14.067 8.5 16 8.5C17.933 8.5 19.5 6.933 19.5 5C19.5 3.067 17.933 1.5 16 1.5Z"
				fill="currentColor"
			/>
			<path
				d="M8 8.5C6.067 8.5 4.5 10.067 4.5 12C4.5 13.933 6.067 15.5 8 15.5C9.933 15.5 11.5 13.933 11.5 12C11.5 10.067 9.933 8.5 8 8.5Z"
				fill="currentColor"
			/>
			<path
				d="M16 15.5C14.067 15.5 12.5 17.067 12.5 19C12.5 20.933 14.067 22.5 16 22.5C17.933 22.5 19.5 20.933 19.5 19C19.5 17.067 17.933 15.5 16 15.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
